import { render } from "./VideoQuizResultsView.vue?vue&type=template&id=231bb591&scoped=true"
import script from "./VideoQuizResultsView.vue?vue&type=script&lang=js"
export * from "./VideoQuizResultsView.vue?vue&type=script&lang=js"

import "./VideoQuizResultsView.vue?vue&type=style&index=0&id=231bb591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231bb591"]])

export default __exports__